import { combineReducers } from 'redux';

import unappliedStudentsReport from './report/reducer';

export default combineReducers({
  unappliedStudentsReport,
});



// WEBPACK FOOTER //
// ./src/pages/unappliedstudents/state/reducer.js